import React from "react";
import { useTranslation } from "react-i18next";
import { Center } from "@/shared/ui/Blocks";
import Circles from "@/shared/ui/Loaders/Circles";
import { TypewriterText } from "@/shared/ui/TypewriterText";

interface RouteLoaderProps {
  /** Already-translated message string. Takes priority over messageKey. */
  loadingMessage?: string;
  /** i18n key resolved internally — handy in route definitions where hooks aren't available. */
  messageKey?: string;
}

/**
 * Loading fallback component for route-based code splitting.
 * Shows a content-area spinner while lazy-loaded route components are loading.
 * Use as a Suspense fallback: <Suspense fallback={<RouteLoader />}>
 */
export function RouteLoader({ loadingMessage, messageKey }: RouteLoaderProps) {
  const { t } = useTranslation();

  return (
    <Center className="h-full flex-1">
      <div className="flex flex-col items-center gap-4">
        <Circles loading />
        <TypewriterText
          text={loadingMessage ?? t(messageKey ?? "common.loading_content")}
        />
      </div>
    </Center>
  );
}

export default RouteLoader;
